(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Highlightable", [], factory);
	else if(typeof exports === 'object')
		exports["Highlightable"] = factory();
	else
		root["Highlightable"] = factory();
})(self, () => {
return 